/**
 * Returns the correct embed domain based on the current environment
 */
export function getEmbedDomain(): string {
  const hostname = window.location.hostname;

  // Production domain
  if (hostname === 'hostvsl.com.br' || hostname === 'www.hostvsl.com.br') {
    return 'https://hostvsl.com.br';
  }

  // Preview/staging domain
  if (hostname.includes('preview') || hostname.includes('staging')) {
    return 'https://preview.hostvsl.com.br';
  }

  // Lovable preview domain
  if (hostname.includes('lovable.app') || hostname.includes('lovable.dev')) {
    return 'https://preview.hostvsl.com.br';
  }

  // Development fallback
  return 'https://preview.hostvsl.com.br';
}

/**
 * Generates embed iframe code for a video.
 */
export function generateVideoEmbedCode(videoId: string): string {
  if (!videoId) return '';
  const domain = getEmbedDomain();
  const containerId = `hvsl-${videoId.replace(/-/g, '').slice(0, 12)}`;
  const desktopPadding = '56.25%'; // default 16:9

  return `<div id="${containerId}" style="padding:${desktopPadding} 0 0 0;position:relative;overflow:hidden;">
  <iframe
    allow="autoplay; fullscreen"
    referrerpolicy="unsafe-url"
    src="${domain}/?video=${videoId}"
    style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"
  ></iframe>
</div>`;
}

/**
 * Generates embed JavaScript code for a video
 */
export function generateVideoJsCode(videoId: string): string {
  const domain = getEmbedDomain();
  return `<script src="${domain}/player.js"></script>
<div id="hostvsl-player" data-video="${videoId}"></div>
<script>
  HostVSL.renderPlayer('#hostvsl-player', { videoId: '${videoId}' });
</script>`;
}